import { render, staticRenderFns } from "./LogsHeader.vue?vue&type=template&id=bb6b5da2&scoped=true&"
import script from "./LogsHeader.vue?vue&type=script&lang=js&"
export * from "./LogsHeader.vue?vue&type=script&lang=js&"
import style0 from "./LogsHeader.vue?vue&type=style&index=0&id=bb6b5da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6b5da2",
  null
  
)

export default component.exports